import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './App.css';
import Main from './Components/Bodycomponent/Main';
import './Components/Css/core.css';
import React, { Component }  from 'react';
function App() {
  return (
    <>
      <Main />
    </>
  );
}

export default App;
